import {getJsonFromUrl} from './helpers';

export function findApplicant() {
    const getParams = getJsonFromUrl(document.location.search);
    if (getParams.competition_code) {
        const competition = $_vikon(`.tr-accordion[data-code=${getParams.competition_code}]`).get(0);
        if (competition) {
            const $competition = $_vikon(competition);
            const competitionIndex = $competition.data('id');
            const competitionApplicants = $_vikon(`tr[data-tr-id=${competitionIndex}]`).get(0);
            if (competitionApplicants) {
                const $competitionApplicants = $_vikon(competitionApplicants);
                if (!$competitionApplicants.is(':visible')) {
                    $competition.click();
                }
                // скролл к абитуриенту
                if (getParams.applicant_code) {
                    const applicant = $competitionApplicants.find(`td[data-code="${getParams.applicant_code}"]`).get(0);
                    if (applicant) {
                        $_vikon('#vikon-content-abitur').animate({scrollTop: $_vikon(applicant).offset().top + $_vikon('#vikon-content-abitur').scrollTop() - 200}, 200);
                        $_vikon(applicant.closest('tr')).addClass('applicant-active');
                    }
                }
            }
        }
    }
}
